import { useEffect, useRef } from "react";

import { useKeywordsCampaignsContext } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContext";

import { COLLECTING_CAMPAIGN_POLL_INTERVAL_MS } from "../constants";

import { useIsCampaignCollecting } from "./useIsCampaignCollecting";
import { useRankTrackerInvalidation } from "./useRankTrackerInvalidation";

export const useCollectingCampaignPoll = (): void => {
    const isCollecting = useIsCampaignCollecting();
    const { currentCampaignConfiguration, updateCurrentCampaign } = useKeywordsCampaignsContext();
    const { removeCampaignQueries } = useRankTrackerInvalidation();
    const wasCollectingRef = useRef(false);
    const campaignId = currentCampaignConfiguration?.id;

    useEffect(() => {
        if (wasCollectingRef.current && !isCollecting && campaignId) {
            // Clear campaign query cache to re-fetch the data
            void removeCampaignQueries({ campaignId });
        }
        wasCollectingRef.current = isCollecting;
    }, [campaignId, isCollecting, removeCampaignQueries]);

    useEffect(() => {
        if (!isCollecting) {
            return;
        }

        const intervalId = window.setInterval(() => {
            void updateCurrentCampaign(true);
        }, COLLECTING_CAMPAIGN_POLL_INTERVAL_MS);

        return () => window.clearInterval(intervalId);
    }, [isCollecting, updateCurrentCampaign]);
};
